import { useState } from "react";
import ExpertDataService from "../services/Expert";
import { useNavigate } from "react-router-dom";
import { useToast } from "@chakra-ui/react";
import {
  Gender,
  Issues,
  Languages,
  SessionDeliveryMode,
  SeverityOfSymptoms,
  Tags,
  Type,
  expert,
  ensureAudienceSessionConfig,
  syncLegacyFromAudienceConfig,
  validateAudienceSessionPricing,
  DeliveryModeValue,
} from "../Config/Expert";
import { MultiSelect } from "react-multi-select-component";
import { ExpertSessionPricingForm } from "../components/Expert/ExpertSessionPricingForm";
import { ExpertProfileOnboardingFields } from "../components/Expert/ExpertProfileOnboardingFields";

export const AddExpert = () => {
  const navigate = useNavigate();
  const toast = useToast();
  const [symptoms, setSymptoms] = useState<any>([]);
  const [is_hidden, setIsHidden] = useState<any>(false);
  const [spotlight, setSpotlight] = useState<any>(false);
  const [is_programme_expert, setIsProgrammeExpert] = useState<any>(false);
  const [is_registartion_allow, setIsRegistartionAllow] = useState<any>(true);
  const [is_in_person_enabled, setIsInPersonEnabled] = useState<any>(true);
  const [is_call_enabled, setIsCallEnabled] = useState<any>(true);
  const [is_video_enabled, setIsInVideoEnabled] = useState<any>(true);
  const [is_chat_enabled, setIsChatEnabled] = useState<any>(false);
  const [language, setLanguage] = useState<any>([]);
  const [severityOfSymptoms, setSeverityOfSymptoms] = useState<any>([]);
  const [expertTags, setExpertTags] = useState<any>([]);
  const [sessionDeliveryMode, setSessionDeliveryMode] = useState<any>([]);
  const [sessionType, setSessionType] = useState<any>([]);
  const [gender, setGender] = useState<any>([]);
  const [bankDetails, setBankDetails] = useState({
    account_holder_name: "",
    account_number: "",
    bank_name: "",
    ifsc_code: "",
  });
  const [manthanDetails, setManthanDetails] = useState({
    is_supervision_active: false,
    supervision_batch_id: "",
    supervision_enrollment_no: "",
  });
  const [audienceSessionConfig, setAudienceSessionConfig] = useState(
    ensureAudienceSessionConfig({}, {}, {})
  );
  const [ageRange, setAgeRange] = useState<any>({ minAge: "", maxAge: "" });
  const [budgetRange, setBudgetRange] = useState<any>({
    minBudget: "",
    maxBudget: "",
  });
  const [feedbackInfo, setFeedbackInfo] = useState<any>({ name: "", text: "" });
  const [expertDetails, setExpertDetails] = useState<any>(expert);
  const [expertPointsDetailsInputs, setExpertPointsDetailsInputs] =
    useState<any>({
      experience_points_inputs: "",
      education_inputs: "",
      area_of_expertise_inputs: "",
      style: "",
      certification: "",
      professional_certification: "",
      feedback_text: "",
    });
  const handleChange = (e: any) => {
    setExpertDetails({
      ...expertDetails,
      [e.target.name]: e.target.value,
    });
  };

  const handleBankeDetailsChange = (e: any) => {
    setBankDetails({
      ...bankDetails,
      [e.target.name]: e.target.value,
    });
  };

  const handleManthaneDetailsChange = (e: any) => {
    setManthanDetails({
      ...manthanDetails,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (event: any) => {
    event.preventDefault();
    const pricingError = validateAudienceSessionPricing(audienceSessionConfig);
    if (pricingError) {
      toast({
        position: "top",
        title: "Invalid Session Pricing",
        description: pricingError,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      return;
    }
    const lead_symptoms = symptoms.map((el: { value: any }) => el.value);
    const lead_language = language.map((el: { value: any }) => el.value);
    const lead_severity = severityOfSymptoms.map(
      (el: { value: any }) => el.value
    );
    const lead_gender = gender.map((el: { value: any }) => el.value);
    const session_delivery_mode = sessionDeliveryMode.map(
      (el: { value: any }) => el.value
    );
    const type = sessionType.map((el: { value: any }) => el.value);
    const tags = expertTags.map((el: { value: any }) => el.value);
    const lead_budget_range = `${budgetRange.minBudget}-${budgetRange.maxBudget}`;
    const lead_age_range = `${ageRange.minAge}-${ageRange.maxAge}`;
    const synced = syncLegacyFromAudienceConfig(audienceSessionConfig, type);
    const data = {
      ...expertDetails,
      is_programme_expert,
      lead_symptoms,
      lead_language,
      lead_gender,
      lead_budget_range,
      lead_age_range,
      lead_severity,
      session_delivery_mode,
      tags,
      type,
      session_price: synced.session_price,
      duration: synced.duration,
      session_duration: synced.session_duration,
      audience_session_config: audienceSessionConfig,
      three_session: synced.three_session,
      five_session: synced.five_session,
      ten_session: synced.ten_session,
      in_person_three_session: synced.in_person_three_session,
      in_person_five_session: synced.in_person_five_session,
      in_person_ten_session: synced.in_person_ten_session,
      call_three_session: synced.call_three_session,
      call_five_session: synced.call_five_session,
      call_ten_session: synced.call_ten_session,
      chat_three_session: synced.chat_three_session,
      chat_five_session: synced.chat_five_session,
      chat_ten_session: synced.chat_ten_session,
      is_hidden,
      spotlight,
      is_in_person_enabled,
      is_call_enabled,
      is_video_enabled,
      is_chat_enabled,
      allow_app_registration: is_registartion_allow,
      bank_details: bankDetails,
      manthan: manthanDetails,
    };
    ExpertDataService.create(data)
      .then((response: any) => {
        navigate("/experts");
      })
      .catch((e: Error) => {
        console.log(e);
      });
  };

  return (
    <div className="main-wrapper">
      <div className="page_title py-2">Experts - App Experts</div>
      <div className="p-5">
        {/* top section */}
        <div className="row m-0 justify-content-center">
          <div className="card p-5 col-lg-10">
            <h2>Basic Info</h2>
            <form
              className="add_assesment_form"
              onSubmit={(e: any) => handleSubmit(e)}
            >
              <div className="form-row mt-3">
                <div className="form-group col-md-2 mb-4 edit-icon ">
                  <label className="form-label" htmlFor="booking_date">
                    Is Hidden
                  </label>
                  <input
                    className="ml-4"
                    type="checkbox"
                    aria-label="Checkbox"
                    value={is_hidden}
                    onChange={(e) => setIsHidden(e.target.checked)}
                    id="is_hidden"
                    name="is_hidden"
                  />
                </div>
                <div className="form-group col-md-2 mb-4 edit-icon ">
                  <label className="form-label" htmlFor="booking_date">
                    Spotlight
                  </label>
                  <input
                    className="ml-4"
                    type="checkbox"
                    aria-label="Checkbox"
                    value={spotlight}
                    onChange={(e) => setSpotlight(e.target.checked)}
                    id="spotlight"
                    name="spotlight"
                  />
                </div>
                <div className="form-group col-md-3 mb-4 edit-icon ">
                  <label className="form-label" htmlFor="booking_date">
                    Allow Registration
                  </label>
                  <input
                    className="ml-4"
                    type="checkbox"
                    aria-label="Checkbox"
                    checked={is_registartion_allow}
                    onChange={(e) => setIsRegistartionAllow(e.target.checked)}
                    id="allow_app_registration"
                    name="allow_app_registration"
                  />
                </div>
                <div className="form-group col-md-2 mb-4 edit-icon ">
                  <label className="form-label" htmlFor="booking_date">
                    Programme
                  </label>
                  <input
                    className="ml-4"
                    type="checkbox"
                    aria-label="Checkbox"
                    checked={is_programme_expert}
                    onChange={(e) => setIsProgrammeExpert(e.target.checked)}
                    id="is_programme_expert"
                    name="is_programme_expert"
                  />
                </div>
                <div className="form-group col-md-2 mb-4 edit-icon ">
                  <label className="form-label" htmlFor="booking_date">
                    Supervision
                  </label>
                  <input
                    className="ml-4"
                    type="checkbox"
                    aria-label="Checkbox"
                    checked={manthanDetails.is_supervision_active}
                    onChange={(e) =>
                      setManthanDetails({
                        ...manthanDetails,
                        is_supervision_active: e.target.checked,
                      })
                    }
                    id="is_supervision_active"
                    name="is_supervision_active"
                  />
                </div>
                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="booking_date">
                    First Name
                  </label>
                  <input
                    onChange={handleChange}
                    type="text"
                    className="form-control"
                    id="first_name"
                    name="first_name"
                  />
                </div>
                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="booking_time">
                    Full Name
                  </label>
                  <input
                    onChange={handleChange}
                    type="text"
                    className="form-control"
                    id="full_name"
                    name="full_name"
                  />
                </div>
                <ExpertProfileOnboardingFields
                  expertDetails={expertDetails}
                  setExpertDetails={setExpertDetails}
                  certificationInput={
                    expertPointsDetailsInputs.professional_certification
                  }
                  setCertificationInput={(value) =>
                    setExpertPointsDetailsInputs({
                      ...expertPointsDetailsInputs,
                      professional_certification: value,
                    })
                  }
                />
                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="booking_time">
                    Age
                  </label>
                  <input
                    onChange={handleChange}
                    type="text"
                    className="form-control"
                    id="age"
                    name="age"
                  />
                </div>
                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="booking_time">
                    About
                  </label>
                  <input
                    onChange={handleChange}
                    type="text"
                    className="form-control"
                    id="about"
                    name="about"
                  />
                </div>
                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="expert">
                    Country Code
                  </label>
                  <input
                    onChange={handleChange}
                    type="text"
                    className="form-control"
                    id="country_code"
                    name="country_code"
                  />
                </div>
                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="expert">
                    Phone Number
                  </label>
                  <input
                    onChange={handleChange}
                    type="text"
                    className="form-control"
                    id="phone_number"
                    name="phone_number"
                  />
                </div>
                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="expert">
                    Whatsapp Phone Number
                  </label>
                  <input
                    onChange={handleChange}
                    type="text"
                    className="form-control"
                    id="whatsapp_phone_number"
                    name="whatsapp_phone_number"
                  />
                </div>
                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="expert">
                    Role
                  </label>
                  <select
                    name="role"
                    onChange={handleChange}
                    className="form-control"
                    id="role"
                  >
                    <option value="">Select Role</option>
                    <option value="clinical_psychologist">
                      Clinical Psychologist
                    </option>
                    <option value="psychiatrist">Psychiatrist</option>
                    <option value="counseling_psychologist">
                      Counseling Psychologist
                    </option>
                    <option value="creative_art_therapist">
                      Creative Art Therapist
                    </option>
                    <option value="yoga_or_meditation_expert">
                      Yoga or Meditation Expert
                    </option>
                    <option value="associate_clinical_psychologist">
                      Associate Clinical Psychologist
                    </option>
                    <option value="neuropsychologist">Neuropsychologist</option>
                    <option value="nutritionist">Nutritionist</option>
                  </select>
                </div>
                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="expert">
                    Personal Email Id
                  </label>
                  <input
                    onChange={handleChange}
                    type="text"
                    className="form-control"
                    id="personal_email_id"
                    name="personal_email_id"
                  />
                </div>
                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="state">
                    Manoshala ID
                  </label>
                  <input
                    onChange={handleChange}
                    type="text"
                    className="form-control"
                    id="manoshala_id"
                    name="manoshala_id"
                  />
                </div>
                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="state">
                    Meeting Link
                  </label>
                  <input
                    onChange={handleChange}
                    type="text"
                    className="form-control"
                    id="meet_link"
                    name="meet_link"
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Manoshala Email Id
                  </label>
                  <input
                    onChange={handleChange}
                    type="text"
                    className="form-control"
                    id="manoshala_email_id"
                    name="manoshala_email_id"
                  />
                </div>
                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="expert">
                    Service Page Link
                  </label>
                  <input
                    onChange={handleChange}
                    type="text"
                    className="form-control"
                    id="service_page_link"
                    name="service_page_link"
                  />
                </div>
                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="service_booking_time">
                    City
                  </label>
                  <select
                    onChange={handleChange}
                    className="form-control"
                    id="city"
                    name="city"
                  >
                    <option value="">Select City</option>
                    <option value="mumbai">Mumbai</option>
                    <option value="delhi_ncr">Delhi NCR</option>
                    <option value="bengaluru">Bengaluru</option>
                    <option value="kolkata">Kolkata</option>
                    <option value="noida">Noida</option>
                    <option value="delhi">Delhi</option>
                    <option value="hyderabad">Hyderabad</option>
                    <option value="coimbatore">Coimbatore</option>
                    <option value="bangalore">Bangalore</option>
                    <option value="ahmedabad">Ahmedabad</option>
                    <option value="baroda">Baroda</option>
                    <option value="madurai">Madurai</option>
                    <option value="vijayawada">Vijayawada</option>
                    <option value="indore">Indore</option>
                    <option value="lucknow">Lucknow</option>
                    <option value="other">Other</option>
                  </select>
                </div>
              </div>
              <div className="form-row">
                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Address
                  </label>
                  <input
                    onChange={handleChange}
                    type="text"
                    className="form-control"
                    id="address"
                    name="address"
                  />
                </div>
                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    State
                  </label>
                  <input
                    onChange={handleChange}
                    type="text"
                    className="form-control"
                    id="state"
                    name="state"
                  />
                </div>
                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="gender">
                    Country
                  </label>
                  <input
                    onChange={handleChange}
                    type="text"
                    className="form-control"
                    id="country"
                    name="country"
                  />
                </div>
                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="state">
                    Pin Code
                  </label>
                  <input
                    onChange={handleChange}
                    type="text"
                    className="form-control"
                    id="pin_code"
                    name="pin_code"
                  />
                </div>
                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="state">
                    Latitude
                  </label>
                  <input
                    onChange={handleChange}
                    type="text"
                    className="form-control"
                    id="latitude"
                    name="latitude"
                  />
                </div>
                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="state">
                    Longitude
                  </label>
                  <input
                    onChange={handleChange}
                    type="text"
                    className="form-control"
                    id="longitude"
                    name="longitude"
                  />
                </div>
                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="city">
                    Onboarding Documents Link
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="onboarding_documents_folder_link"
                    name="onboarding_documents_folder_link"
                    onChange={handleChange}
                    defaultValue=""
                  />
                </div>
                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="budget">
                    Contact Documents Link
                  </label>
                  <input
                    onChange={handleChange}
                    type="text"
                    className="form-control"
                    id="contract_documents_folder_link"
                    name="contract_documents_folder_link"
                  />
                </div>
                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="student">
                    Photograph Link
                  </label>
                  <input
                    onChange={handleChange}
                    type="text"
                    className="form-control"
                    id="photograph_link"
                    name="photograph_link"
                  />
                </div>
                <h2>App Info</h2>
                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Session Duration
                  </label>
                  <input
                    onChange={handleChange}
                    type="text"
                    className="form-control"
                    id="session_duration"
                    name="session_duration"
                  />
                </div>
                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Session Head Start Count
                  </label>
                  <input
                    onChange={handleChange}
                    type="text"
                    className="form-control"
                    id="session_head_start_count"
                    name="session_head_start_count"
                  />
                </div>
                <h5 className="form-group col-md-12 ">Session Price</h5>
                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Default Session Price
                  </label>
                  <input
                    onChange={handleChange}
                    type="text"
                    className="form-control"
                    id="default_session_price"
                    name="default_session_price"
                  />
                </div>
                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Discounted Price
                  </label>
                  <input
                    onChange={handleChange}
                    type="text"
                    className="form-control"
                    id="discounted_price"
                    name="discounted_price"
                  />
                </div>
                <ExpertSessionPricingForm
                  audienceConfig={audienceSessionConfig}
                  onAudienceChange={setAudienceSessionConfig}
                  enabled={{
                    in_person: is_in_person_enabled,
                    video: is_video_enabled,
                    call: is_call_enabled,
                    chat: is_chat_enabled,
                  }}
                  onEnabledChange={(mode: DeliveryModeValue, value) => {
                    if (mode === "in_person") setIsInPersonEnabled(value);
                    if (mode === "video") setIsInVideoEnabled(value);
                    if (mode === "call") setIsCallEnabled(value);
                    if (mode === "chat") setIsChatEnabled(value);
                  }}
                  selectedTypes={sessionType.map(
                    (el: { value: any }) => el.value
                  )}
                />
                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Tags
                  </label>
                  <MultiSelect
                    options={Tags}
                    labelledBy="Select Tags"
                    value={expertTags}
                    onChange={setExpertTags}
                  />
                </div>
                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Session Delivery Mode
                  </label>
                  <MultiSelect
                    options={SessionDeliveryMode}
                    labelledBy="Select Delivery Mode "
                    value={sessionDeliveryMode}
                    onChange={setSessionDeliveryMode}
                  />
                </div>
                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Type
                  </label>
                  <MultiSelect
                    options={Type}
                    labelledBy="Select types"
                    value={sessionType}
                    onChange={setSessionType}
                  />
                </div>
                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Rating
                  </label>
                  <input
                    onChange={handleChange}
                    type="text"
                    className="form-control"
                    id="rating"
                    name="rating"
                  />
                </div>
                <h6 className="form-group col-md-12 mb-4">Message</h6>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Title
                  </label>
                  <input
                    onChange={handleChange}
                    type="text"
                    className="form-control"
                    id="title"
                    name="title"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Detail
                  </label>
                  <input
                    onChange={handleChange}
                    type="text"
                    className="form-control"
                    id="details"
                    name="details"
                  />
                </div>
                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Voice note link
                  </label>
                  <input
                    onChange={handleChange}
                    type="text"
                    className="form-control"
                    id="voice_note_link"
                    name="voice_note_link"
                  />
                </div>
                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    No of patients
                  </label>
                  <input
                    onChange={handleChange}
                    type="text"
                    className="form-control"
                    id="no_of_patients"
                    name="no_of_patients"
                  />
                </div>
                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Gender
                  </label>
                  <select
                    onChange={handleChange}
                    className="form-control"
                    id="gender"
                    name="gender"
                  >
                    <option value="">Select Gender</option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                    <option value="other">Other</option>
                  </select>
                </div>
                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Approach to therapy
                  </label>
                  <input
                    onChange={handleChange}
                    type="text"
                    className="form-control"
                    id="approach_to_therapy"
                    name="approach_to_therapy"
                  />
                </div>
                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    First session
                  </label>
                  <input
                    onChange={handleChange}
                    type="text"
                    className="form-control"
                    id="first_session"
                    name="first_session"
                  />
                </div>
                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="service_booking_time">
                    Style
                  </label>
                  <div className="input-group">
                    <input
                      value={expertPointsDetailsInputs.style}
                      onChange={(e) =>
                        setExpertPointsDetailsInputs({
                          ...expertPointsDetailsInputs,
                          style: e.target.value,
                        })
                      }
                      type="text"
                      className="form-control"
                      id="style"
                      name="style"
                    />
                    <button
                      className="btn btn-primary ml-2"
                      type="button"
                      onClick={() => {
                        const style_points = [...expertDetails.style];
                        style_points.push(expertPointsDetailsInputs.style);
                        setExpertDetails({
                          ...expertDetails,
                          style: style_points,
                        });
                        setExpertPointsDetailsInputs({
                          ...expertPointsDetailsInputs,
                          style: "",
                        });
                      }}
                    >
                      Add
                    </button>
                  </div>
                </div>
                {expertDetails.style.length > 0 && (
                  <ul className="added-data-list">
                    {expertDetails.style.map((item: any, index: number) => (
                      <li key={index}>
                        {item}

                        <span
                          className="close-icon"
                          onClick={() => {
                            const style = [...expertDetails.style];
                            style.splice(index, 1);
                            setExpertDetails({
                              ...expertDetails,
                              style,
                            });
                          }}
                        >
                          &#10006;
                        </span>
                      </li>
                    ))}
                  </ul>
                )}
                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="service_booking_time">
                    Cerifications
                  </label>
                  <div className="input-group">
                    <input
                      value={expertPointsDetailsInputs.certification}
                      onChange={(e) =>
                        setExpertPointsDetailsInputs({
                          ...expertPointsDetailsInputs,
                          certification: e.target.value,
                        })
                      }
                      type="text"
                      className="form-control"
                      id="certification"
                      name="certification"
                    />
                    <button
                      className="btn btn-primary ml-2"
                      type="button"
                      onClick={() => {
                        const certifications = [
                          ...expertDetails.certifications,
                        ];
                        certifications.push(
                          expertPointsDetailsInputs.certification
                        );
                        setExpertDetails({
                          ...expertDetails,
                          certifications,
                        });
                        setExpertPointsDetailsInputs({
                          ...expertPointsDetailsInputs,
                          certification: "",
                        });
                      }}
                    >
                      Add
                    </button>
                  </div>
                </div>
                {expertDetails.certifications.length > 0 && (
                  <ul className="added-data-list">
                    {expertDetails.certifications.map(
                      (item: any, index: number) => (
                        <li key={index}>
                          {item}

                          <span
                            className="close-icon"
                            onClick={() => {
                              const certifications = [
                                ...expertDetails.certifications,
                              ];
                              certifications.splice(index, 1);
                              setExpertDetails({
                                ...expertDetails,
                                certifications,
                              });
                            }}
                          >
                            &#10006;
                          </span>
                        </li>
                      )
                    )}
                  </ul>
                )}
                <div className="form-group col-md-12 mb-4">Feedback</div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="service_booking_time">
                    Name
                  </label>
                  <div className="input-group">
                    <input
                      value={feedbackInfo.name}
                      onChange={(e) =>
                        setFeedbackInfo({
                          ...feedbackInfo,
                          name: e.target.value,
                        })
                      }
                      type="text"
                      className="form-control"
                      id="feedback_name"
                      name="feedback_name"
                    />
                  </div>
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="service_booking_time">
                    text
                  </label>
                  <div className="input-group">
                    <input
                      value={feedbackInfo.text}
                      onChange={(e) =>
                        setFeedbackInfo({
                          ...feedbackInfo,
                          text: e.target.value,
                        })
                      }
                      type="text"
                      className="form-control"
                      id="feedback_text"
                      name="feedback_text"
                    />
                    <button
                      className="btn btn-primary ml-2"
                      type="button"
                      onClick={() => {
                        const feedback = [...expertDetails.feedback];
                        feedback.push(feedbackInfo);
                        setExpertDetails({
                          ...expertDetails,
                          feedback,
                        });
                        setFeedbackInfo({ name: "", text: "" });
                      }}
                    >
                      Add
                    </button>
                  </div>
                </div>
                {expertDetails.feedback.length > 0 && (
                  <ul className="added-data-list">
                    {expertDetails.feedback.map((item: any, index: number) => (
                      <li key={index}>
                        {item.name + ":-" + item.text}

                        <span
                          className="close-icon"
                          onClick={() => {
                            const feedback = [...expertDetails.feedback];
                            feedback.splice(index, 1);
                            setExpertDetails({
                              ...expertDetails,
                              feedback,
                            });
                          }}
                        >
                          &#10006;
                        </span>
                      </li>
                    ))}
                  </ul>
                )}
                <h2>PDF Data</h2>
                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="service_booking_time">
                    Specialization
                  </label>
                  <input
                    onChange={handleChange}
                    type="text"
                    className="form-control"
                    id="specialization"
                    name="specialization"
                  />
                </div>
                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="service_booking_time">
                    Description
                  </label>
                  <input
                    onChange={handleChange}
                    type="text"
                    className="form-control"
                    id="description"
                    name="description"
                  />
                </div>
                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="service_booking_time">
                    Work Experience (in years)
                  </label>
                  <input
                    onChange={handleChange}
                    type="text"
                    className="form-control"
                    id="total_experience"
                    name="total_experience"
                  />
                </div>
                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="service_booking_time">
                    Work Experience Points
                  </label>
                  <div className="input-group">
                    <input
                      value={expertPointsDetailsInputs.experience_points_inputs}
                      onChange={(e) =>
                        setExpertPointsDetailsInputs({
                          ...expertPointsDetailsInputs,
                          experience_points_inputs: e.target.value,
                        })
                      }
                      type="text"
                      className="form-control"
                      id="experience_points"
                      name="experience_points"
                    />
                    <button
                      className="btn btn-primary ml-2"
                      type="button"
                      onClick={() => {
                        const experience_points = [
                          ...expertDetails.experience_points,
                        ];
                        experience_points.push(
                          expertPointsDetailsInputs.experience_points_inputs
                        );
                        setExpertDetails({
                          ...expertDetails,
                          experience_points,
                        });
                        setExpertPointsDetailsInputs({
                          ...expertPointsDetailsInputs,
                          experience_points_inputs: "",
                        });
                      }}
                    >
                      Add
                    </button>
                  </div>
                </div>
                {expertDetails.experience_points.length > 0 && (
                  <ul className="added-data-list">
                    {expertDetails.experience_points.map(
                      (item: any, index: number) => (
                        <li key={index}>
                          {item}

                          <span
                            className="close-icon"
                            onClick={() => {
                              const experience_points = [
                                ...expertDetails.experience_points,
                              ];
                              experience_points.splice(index, 1);
                              setExpertDetails({
                                ...expertDetails,
                                experience_points,
                              });
                            }}
                          >
                            &#10006;
                          </span>
                        </li>
                      )
                    )}
                  </ul>
                )}
                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="service_booking_time">
                    Education
                  </label>
                  <div className="input-group">
                    <input
                      value={expertPointsDetailsInputs.education_inputs}
                      onChange={(e) =>
                        setExpertPointsDetailsInputs({
                          ...expertPointsDetailsInputs,
                          education_inputs: e.target.value,
                        })
                      }
                      type="text"
                      className="form-control"
                      id="education"
                      name="education"
                    />
                    <button
                      className="btn btn-primary ml-2"
                      type="button"
                      onClick={() => {
                        const education = [...expertDetails.education];
                        education.push(
                          expertPointsDetailsInputs.education_inputs
                        );
                        setExpertDetails({
                          ...expertDetails,
                          education,
                        });
                        setExpertPointsDetailsInputs({
                          ...expertPointsDetailsInputs,
                          education_inputs: "",
                        });
                      }}
                    >
                      Add
                    </button>
                  </div>
                </div>
                {expertDetails.education.length > 0 && (
                  <ul className="added-data-list">
                    {expertDetails.education.map((item: any, index: number) => (
                      <li key={index}>
                        {item}

                        <span
                          className="close-icon"
                          onClick={() => {
                            const education = [...expertDetails.education];
                            education.splice(index, 1);
                            setExpertDetails({
                              ...expertDetails,
                              education,
                            });
                          }}
                        >
                          &#10006;
                        </span>
                      </li>
                    ))}
                  </ul>
                )}
                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="service_booking_time">
                    Area of Expertise
                  </label>
                  <div className="input-group">
                    <input
                      value={expertPointsDetailsInputs.area_of_expertise_inputs}
                      onChange={(e) =>
                        setExpertPointsDetailsInputs({
                          ...expertPointsDetailsInputs,
                          area_of_expertise_inputs: e.target.value,
                        })
                      }
                      type="text"
                      className="form-control"
                      id="area_of_expertise"
                      name="area_of_expertise"
                    />
                    <button
                      className="btn btn-primary ml-2"
                      type="button"
                      onClick={() => {
                        const area_of_expertise = [
                          ...expertDetails.area_of_expertise,
                        ];
                        area_of_expertise.push(
                          expertPointsDetailsInputs.area_of_expertise_inputs
                        );
                        setExpertDetails({
                          ...expertDetails,
                          area_of_expertise,
                        });
                        setExpertPointsDetailsInputs({
                          ...expertPointsDetailsInputs,
                          area_of_expertise_inputs: "",
                        });
                      }}
                    >
                      Add
                    </button>
                  </div>
                </div>
                {expertDetails.area_of_expertise.length > 0 && (
                  <ul className="added-data-list">
                    {expertDetails.area_of_expertise.map(
                      (item: any, index: number) => (
                        <li key={index}>
                          {item}

                          <span
                            className="close-icon"
                            onClick={() => {
                              const area_of_expertise = [
                                ...expertDetails.area_of_expertise,
                              ];
                              area_of_expertise.splice(index, 1);
                              setExpertDetails({
                                ...expertDetails,
                                area_of_expertise,
                              });
                            }}
                          >
                            &#10006;
                          </span>
                        </li>
                      )
                    )}
                  </ul>
                )}
                <h2>AESS Data</h2>
                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Lead Symptoms
                  </label>
                  <MultiSelect
                    options={Issues}
                    labelledBy="Select Symptoms"
                    value={symptoms}
                    onChange={setSymptoms}
                  />
                </div>
                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Lead Gender
                  </label>
                  <MultiSelect
                    options={Gender}
                    labelledBy="Select gender"
                    value={gender}
                    onChange={setGender}
                  />
                </div>
                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Severity of Symptoms
                  </label>
                  <MultiSelect
                    options={SeverityOfSymptoms}
                    labelledBy="Select..."
                    value={severityOfSymptoms}
                    onChange={setSeverityOfSymptoms}
                  />
                </div>
                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Lead Language
                  </label>
                  <MultiSelect
                    options={Languages}
                    labelledBy="Select languages"
                    value={language}
                    onChange={setLanguage}
                  />
                </div>
                <h5 className="form-group col-md-12 mb-4">Lead Budget Range</h5>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    from
                  </label>
                  <input
                    value={budgetRange.minBudget}
                    onChange={(e) =>
                      setBudgetRange({
                        ...budgetRange,
                        minBudget: e.target.value,
                      })
                    }
                    type="text"
                    className="form-control"
                    id="budgetRange"
                    name="budgetRange"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    to
                  </label>
                  <input
                    value={budgetRange.maxBudget}
                    onChange={(e) =>
                      setBudgetRange({
                        ...budgetRange,
                        maxBudget: e.target.value,
                      })
                    }
                    type="text"
                    className="form-control"
                    id="budgetRange"
                    name="budgetRange"
                  />
                </div>
                <h5 className="form-group col-md-12 mb-4">Lead Age Range</h5>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    from
                  </label>
                  <input
                    value={ageRange.minAge}
                    onChange={(e) =>
                      setAgeRange({ ...ageRange, minAge: e.target.value })
                    }
                    type="text"
                    className="form-control"
                    id="experience_points"
                    name="experience_points"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    to
                  </label>
                  <input
                    value={ageRange.maxAge}
                    onChange={(e) =>
                      setAgeRange({ ...ageRange, maxAge: e.target.value })
                    }
                    type="text"
                    className="form-control"
                    id="experience_points"
                    name="experience_points"
                  />
                </div>
                <h2>Bank Details</h2>
                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Account Holder Name
                  </label>
                  <input
                    value={bankDetails.account_holder_name}
                    onChange={handleBankeDetailsChange}
                    type="text"
                    className="form-control"
                    id="account_holder_name"
                    name="account_holder_name"
                  />
                </div>
                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Account Number
                  </label>
                  <input
                    value={bankDetails.account_number}
                    onChange={handleBankeDetailsChange}
                    type="text"
                    className="form-control"
                    id="account_number"
                    name="account_number"
                  />
                </div>
                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Bank Name
                  </label>
                  <input
                    value={bankDetails.bank_name}
                    onChange={handleBankeDetailsChange}
                    type="text"
                    className="form-control"
                    id="bank_name"
                    name="bank_name"
                  />
                </div>
                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    IFSC Code
                  </label>
                  <input
                    value={bankDetails.ifsc_code}
                    onChange={handleBankeDetailsChange}
                    type="text"
                    className="form-control"
                    id="ifsc_code"
                    name="ifsc_code"
                  />
                </div>
                <h2>Manthan Details</h2>
                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Supervision Batch Id
                  </label>
                  <input
                    value={manthanDetails.supervision_batch_id}
                    onChange={handleManthaneDetailsChange}
                    type="text"
                    className="form-control"
                    id="supervision_batch_id"
                    name="supervision_batch_id"
                  />
                </div>
                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Supervision Enrollment Number
                  </label>
                  <input
                    value={manthanDetails.supervision_enrollment_no}
                    onChange={handleManthaneDetailsChange}
                    type="text"
                    className="form-control"
                    id="supervision_enrollment_no"
                    name="supervision_enrollment_no"
                  />
                </div>
              </div>
              <button
                type="submit"
                className="btn action-btn mt-3 px-5 submit-button"
              >
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};